module.exports = __webpack_public_path__ + "89865ddb0c3bc261be8bddf8645b8d90.woff2";